import * as types from './types';

const initialState = {
  GetLeadershipStaffDevelopment: {},
  PostLeadershipStaffDevelopment: {}
};

export default function clientsReducer(state = initialState, action) {
  switch (action.type) {
    case 'RESET_KEY':
      return {
        ...state,
        [action.payload.key]: {}
      };
    case types.GET_LEADERSHIP_STAFF_DEVELOPMENT_SUCCESS: {
      return {
        ...state,
        GetLeadershipStaffDevelopment: action.payload
      };
    }
    case types.GET_LEADERSHIP_STAFF_DEVELOPMENT_FAILURE:
      return { ...state, error: action.payload };

    case types.POST_LEADERSHIP_STAFF_DEVELOPMENT_SUCCESS: {
      return {
        ...state,
        PostLeadershipStaffDevelopment: action.payload
      };
    }
    case types.POST_LEADERSHIP_STAFF_DEVELOPMENT_FAILURE:
      return { ...state, error: action.payload };

    default:
      return state;
  }
}
